import React from "react";
import footerImage from "../../assets/images/footer.png";
export default function Footer({ withFooterImage }) {
  return (
    <footer>
      {withFooterImage && (
        <img
          quality={100}
          src={footerImage}
          priority="true"
          alt="Footer Burger Kin"
          className="mx-auto mobile-only max-w-[215px]"
        />
      )}
      <p className="reserve-rights">© 2025 Costa, all rights reserved</p>

      <p>
        <a
          href="https://www.costa.co.uk/privacy-policy"
          rel="noreferrer"
          target="_blank"
        >
          Privacy Policy
        </a>{" "}
        |{" "}
        <a href="/terms" target="_blank">
          Terms & Conditions
        </a>
        <span className="hidden md:inline-block">&nbsp; | &nbsp; </span>
        <br className="md:hidden" />
        <a href="/prizes" target="_blank">
          Prizes
        </a>
        {" | "}
        <a href="/locations" target="_blank">
          Locations
        </a>{" "}
      </p>
    </footer>
  );
}
